import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { SurveySchema } from '../../entities/survey';
/**
 * Finalize Process Step Recording Request Schema
 * POST /api/v2/process-step-recording/:id/finalize
 * Body carries the user-approved name/description that overwrite the AI
 * suggestion (or are entered manually when AI is disabled).
 */ export const FinalizeProcessStepRecordingRequestSchema = z.object({
    name: z.string().min(1),
    description: z.string().min(1)
});
/**
 * Finalize Process Step Recording Response Schema
 * Returns the created pending survey for the step recording. Shape matches the
 * old /finish endpoint so post-finalize navigation code stays unchanged.
 */ export const FinalizeProcessStepRecordingResponseSchema = z.object({
    survey: SurveySchema.nullable()
});
export const FinalizeProcessStepRecordingErrorSchema = BaseErrorSchema;

//# sourceMappingURL=finalize-process-step-recording.schema.js.map